// extracted by mini-css-extract-plugin
export default {"agentLogoWrapper":"AgentLogo_agentLogoWrapper__M3o-n","agentLogo":"AgentLogo_agentLogo__QGf0w"};